export enum EContainerType {
  FULL_WIDTH = 'FULL_WIDTH',
  PAGE = 'PAGE',
  CONTENT = 'CONTENT',
  DEFAULT = 'DEFAULT',
  SHOP_PAGE = 'SHOP_PAGE',
  SHOP_CONTENT = 'SHOP_CONTENT',
}
